
import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './styles/index.css';
import './App.css';
import { LanguageProvider } from './contexts/LanguageContext';
import { Navbar, GovBar, Footer, FloatingActionButton } from './components';
import { HomePage, PrivacyPage } from './pages';

/**
 * Main Application Component
 * 
 * This is the root component that sets up the application structure including:
 * - Language context provider for internationalization
 * - Router configuration for client-side navigation
 * - Global layout components (navigation, footer, etc.)
 * - Page routing using dedicated page components
 * 
 * Architecture Notes:
 * - Uses page components from /pages directory for better separation
 * - Layout components are shared across all pages
 * - Language context provides Arabic/English support with RTL
 * - Accessibility features included (skip links, ARIA attributes)
 */
function App() {
  useEffect(() => {
    // Set Arabic as default language and RTL direction
    document.documentElement.dir = 'rtl';
    document.documentElement.lang = 'ar';
  }, []);

  return (
    <LanguageProvider>
      <Router>
        <div className="App">
          {/* Skip to content for keyboard users - accessibility feature */}
          <a href="#main-content" className="skip-link">
            تخطي إلى المحتوى
          </a>
          
          {/* Global header components */}
          <GovBar />
          <Navbar />
          
          {/* Main content area with page routing */}
          <main id="main-content" tabIndex="-1">
            <Routes>
              {/* Home page - main landing experience */}
              <Route path="/" element={<HomePage />} />
              
              {/* Privacy policy page - legal compliance */}
              <Route path="/privacy-policy" element={<PrivacyPage />} />
            </Routes>
          </main>
          
          {/* Global footer components */}
          <Footer />
          <FloatingActionButton />
        </div>
      </Router>
    </LanguageProvider>
  );
}

export default App;
